import { EnvConfig } from '@config';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const FEEDBACK_EVENT_PREFIX = 'FEEDBACK_';
export const LESSON_LEARNT_APPROVED_EVENT = 'LESSON_LEARNT_APPROVED';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: EnvConfig.instrumentationKey,
    enableAutoRouteTracking: true,
    maxBatchInterval: 0,
    disableFetchTracking: false,
  },
});
appInsights.loadAppInsights();
appInsights.addTelemetryInitializer(envelope => {
  envelope.tags = envelope.tags ?? {};
  envelope.tags['ai.cloud.role'] = 'drillx-so-front';
});

export const setAuthenticatedUser = (authenticatedUserId: string, accountId: string) => {
  appInsights.setAuthenticatedUserContext(authenticatedUserId, accountId, true);
};

export const loadedAppInsights = appInsights;
